
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.333 14.668c-.333 0-.666-.067-1-.267C.4 13.868.067 12.6.6 11.668L6.267 2.2c.2-.267.4-.533.666-.667.467-.266 1-.333 1.534-.2.533.134.933.467 1.266.934l5.6 9.4c.2.333.267.666.267 1 0 .533-.2 1.066-.6 1.4-.333.4-.8.6-1.333.6H2.333zM7.4 2.934l-5.6 9.4c-.2.334-.067.734.267.934.066.066.2.066.266.066H13.6c.2 0 .333-.066.467-.2a.605.605 0 00.2-.466c0-.134 0-.2-.067-.334l-5.6-9.4c-.2-.333-.6-.4-.933-.266a.52.52 0 00-.267.266z"}}),_c('path',{attrs:{"d":"M8 9.334c-.4 0-.667-.266-.667-.666V6c0-.4.267-.667.667-.667s.667.267.667.667v2.667c0 .4-.267.666-.667.666zM8 12a.605.605 0 01-.467-.2.605.605 0 01-.2-.466c0-.066 0-.2.067-.266.067-.067.067-.134.133-.2.067-.067.134-.134.2-.134.134-.066.267-.066.4-.066.067 0 .067 0 .134.066.066 0 .066 0 .133.067 0 0 .067.067.133.067.067.066.134.133.134.2 0 .066.066.2.066.266 0 .2-.066.334-.2.467-.2.133-.333.2-.533.2z"}})])
          )
        }
      }
    